import { range } from "lodash";
import { getWidth } from "../common";

const columns = 12;
export default range(12).map(current => {
  const field = `switch_door_power_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true
  };
});
